import { Box, useMantineTheme } from '@mantine/core';

import { motion } from 'framer-motion';

import { PRIMARY_FONT } from '../../constants/fonts';
import { MusicSuggestionForm } from '../Forms/MusicSuggestionForm';

const MusicSection = () => {
  const theme = useMantineTheme();
  return (
    <Box
      id="music"
      py={100}
      style={{
        background: 'linear-gradient(180deg, #fafafa 0%, #ffffff 50%, #f0fdf4 100%)',
        position: 'relative',
      }}
    >
      {/* Decorative background elements */}
      <Box
        style={{
          position: 'absolute',
          top: '10%',
          right: '15%',
          width: '140px',
          height: '140px',
          background: `radial-gradient(circle, rgba(${parseInt(theme.other.titleColor.slice(1, 3), 16)}, ${parseInt(theme.other.titleColor.slice(3, 5), 16)}, ${parseInt(theme.other.titleColor.slice(5, 7), 16)}, 0.08) 0%, transparent 70%)`,
          borderRadius: '50%',
          zIndex: 0,
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
        viewport={{ once: true }}
        style={{ position: 'relative', zIndex: 1 }}
      >
        <MusicSuggestionForm />
      </motion.div>
    </Box>
  );
};

export { MusicSection };
export default MusicSection;
